import React from 'react';
import clsx from 'clsx';
import { FieldLabel } from './FieldLabel';
import { FieldError } from './FieldError';

interface Props {
  children: React.ReactNode;
  className?: string;
  additionalClasses?: string;
  labelClasses?: string;
  additionalLabelClasses?: string;
  name?: string;
  label?: string;
  isError?: boolean;
  error?: string;
  toolTip?: string;
  skipError?: boolean;
  skipLabel?: boolean;
  labelBtn?: () => void;
  labelBtnType?: string;
  fieldLabelClasses?: string;
  errorClassName?: string;
  hideIcon?: boolean;
  fieldLabelBtnClasses?: string;
}

export function FieldWrapper({
  children,
  className,
  labelClasses,
  additionalClasses,
  additionalLabelClasses,
  name,
  label,
  toolTip,
  isError,
  error,
  skipError = false,
  skipLabel = false,
  fieldLabelClasses,
  labelBtnType,
  errorClassName,
  hideIcon,
  fieldLabelBtnClasses,
  labelBtn,
  ...rest
}: Props) {
  return (
    <div className={clsx(!className && 'flex flex-col w-full mb-3', className, additionalClasses)} {...rest}>
      {!skipLabel && (
        <FieldLabel
          toolTip={toolTip}
          labelClasses={labelClasses}
          additionalLabelClasses={additionalLabelClasses}
          htmlFor={name}
          labelBtn={labelBtn}
          labelBtnType={labelBtnType}
          fieldLabelClasses={fieldLabelClasses}
          hideIcon={hideIcon}
          fieldLabelBtnClasses={fieldLabelBtnClasses}
        >
          {label}
        </FieldLabel>
      )}
      {children}
      {!skipError && <FieldError error={error} isError={isError} name={name} errorClassName={errorClassName} />}
    </div>
  );
}

export function FieldSetWrapper({ children, className, label, isError, error, skipError, skipLabel }: Props) {
  return (
    <fieldset className={clsx('flex flex-col w-full mb-3', className)}>
      {!skipLabel && (
        <legend className='block mb-2 text-sm font-normal tracking-wide font-effra text-primary-500'>{label}</legend>
      )}
      {children}
      {!skipError && <FieldError error={error} isError={isError} />}
    </fieldset>
  );
}
